<template>
  <CommunityStars />
</template>

<script setup>
// 正确写法：默认导出的组件不需要加 { }
import CommunityStars from '@/components/CommunityStars.vue'
</script>

<style scoped>
/* 你可以在这里写样式 */
</style>